import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  sideBarTitle = "";
  blockOverlay = false;
  #isSideBarVisible = false;

  get isSideBarOpen(): boolean {
    return this.#isSideBarVisible;
  }

  isSideBarVisible(sideBarTitle: string): boolean{
    return this.#isSideBarVisible && this.sideBarTitle == sideBarTitle;
  }

  hide(): void {
    this.sideBarTitle = "";
    if(this.blockOverlay) this.blockOverlay = false;
    this.#isSideBarVisible = false;
  }

  show(sideBarTitle: string, blockOverlay?: boolean): void {
    this.sideBarTitle = sideBarTitle;
    if(blockOverlay) this.blockOverlay = blockOverlay;
    this.#isSideBarVisible = true;
  }
}
